export default {"src":"/_next/static/media/linkedin-icon.fcccb078.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};